/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function ComplexStatisticsCard({ color, title, count, percentage, icon, lines }) {
    return (
        <Card>
            <MDBox display="flex" justifyContent="space-between" pt={0} px={2} height="5rem">
                <MDBox
                    variant="gradient"
                    bgColor={color}
                    color={color === "light" ? "dark" : "white"}
                    coloredShadow={color}
                    borderRadius="xl"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="3rem"
                    height="3rem"
                    mt={-2}
                >
                    <Icon fontSize="medium" color="inherit">
                        {icon}
                    </Icon>
                </MDBox>
                <MDBox textAlign="right" lineHeight={0.5}>
                    {lines === 1 ? (
                        <MDTypography
                            variant="h5"
                            component="div" // Force le rendu d'un <div> au lieu d'un élément inline comme <p>
                            mt={4.5}>
                            {count}
                            <MDTypography
                                variant="button"
                                fontWeight="light"
                                color="dark"
                                ml={1}
                                fontSize="1.1rem">
                                {title}
                            </MDTypography>
                        </MDTypography>
                    ) : lines === 2 ? (
                        <MDTypography component="div" mt={1.5}>
                            <MDTypography
                                variant="button"
                                fontWeight="light"
                                color="dark"
                                fontSize="1.1rem">
                                {title}
                            </MDTypography>
                            <MDTypography
                                variant="h5"
                                component="div" // Force le rendu d'un <div> au lieu d'un élément inline comme <p>
                                mt={-1}>
                                {count}
                            </MDTypography>
                        </MDTypography>
                    ) : null}
                </MDBox>

            </MDBox>
        </Card>
    );
}

// Setting default values for the props of ComplexStatisticsCard
ComplexStatisticsCard.defaultProps = {
    color: "info",
    percentage: {
        color: "success",
        text: "",
        label: "",
    },
};

// Typechecking props for the ComplexStatisticsCard
ComplexStatisticsCard.propTypes = {
    color: PropTypes.oneOf([
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "light",
        "dark",
    ]),
    title: PropTypes.string.isRequired,
    count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    percentage: PropTypes.shape({
        color: PropTypes.oneOf([
            "primary",
            "secondary",
            "info",
            "success",
            "warning",
            "error",
            "dark",
            "white",
        ]),
        amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string,
    }),
    icon: PropTypes.node.isRequired,
};

export default ComplexStatisticsCard;
